import { twMerge } from 'tailwind-merge'

export default function NewLabel({ className, style }: StyleProps) {
  return (
    <span
      className={twMerge(
        'inline-block px-1 py-0.5 text-[10px] leading-none font-normal text-white bg-gradient-purple-pink rounded-sm',
        className,
      )}
      style={style}
    >
      NEW
    </span>
  )
}
